import { ExperimentState } from './experiment-state-model';

export function isStateRunning(state?: ExperimentState) {
  return state === 'running';
}

export function isStateIdle(state?: ExperimentState) {
  return state === 'idle';
}
